import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=0985544a&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0985544a')) {
      api.createRecord('0985544a', component.options)
    } else {
      api.reload('0985544a', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=0985544a&", function () {
      api.rerender('0985544a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z2wjo4nUn78K/JS/ImageCarousel.vue"
export default component.exports